
      // Conditionally load mock or production entry
      if (import.meta.env.MODE === 'development') {
        import('/mocks/index.tsx');
      }
      import('/src/index.tsx');
    